import React from "react";
import {
  ConsentDocumentActiveStage,
  ConsentDocumentSignatory,
  ConsentDocumentStatus,
} from "@source/api/models/consentModels";
import {getConsentStatusPresentation} from "@source/api/models/consentHelpers";
import styles from "./consentShared.module.scss";

export interface ConsentStatusLabelProps {
  status: ConsentDocumentStatus;
  activeStages?: ConsentDocumentActiveStage[];
  signatories?: ConsentDocumentSignatory[];
  className?: string;
}

export const ConsentStatusLabel = ({
  status,
  activeStages,
  signatories,
  className = "",
}: ConsentStatusLabelProps) => {
  const presentation = getConsentStatusPresentation(status, activeStages);
  return (
    <span
      className={`${styles.status} ${styles[`status_${presentation.tone}`]} ${className}`}
      aria-label={`Document status: ${presentation.label}`}
    >
      {presentation.label}
    </span>
  );
};
